import navigation from './navigation-menu'
import router from './router'

export default {
  router,
  navigation,
}
